<template>
  <div id="main" @click="documentClick">
    <div id="top">
      <img class="top-logo" v-lazy='require("@/assets/img/index/logo.png")' @click='checkMenu("/home")'>
      <span class="top-menu" @click="expandMenu()">
         <img class="menu" v-show="!menu.show" v-lazy='require("@/assets/img/index/menu.png")'>
         <img class="menu-close" v-show="menu.show" v-lazy='require("@/assets/img/index/menu-close.png")'>
      </span>
    </div>
    <ul id="menuDetail" :style="{height: menu.show ? 'calc(100vh - 5.6rem)' : 0}">
      <li>
        <div class="menu-item" @click='checkMenu("/home")'>
          <span class="text">首页</span>
        </div>
      </li>
      <li>
        <div class="menu-item" @click='checkMenu("/product")'>
          <span class="text">产品</span>
          <img class="arrow bottom" v-show='menu.expand=="/product"'
               v-lazy='require("@/assets/img/index/menu-arrow-bottom.png")'>
          <img class="arrow right" v-show='menu.expand!="/product"'
               v-lazy='require("@/assets/img/index/menu-arrow-right.png")'>
        </div>
        <div class="menu-detail" v-show='menu.expand=="/product"'>
          <p class="menu-detail-item" @click='checkMenu("/product/l30")'>
            <img class="img" :src='require("@/assets/img/index/menu-product-l30.png")'>
            <span class="title">Lumina耀雅系列<br/>L30</span>
            <img class="new-icon" :src="require('@/assets/img/index/new-icon.png')" />
          </p>
          <p class="menu-detail-item" @click='checkMenu("/product/e10")'>
            <img class="img" :src='require("@/assets/img/index/menu-product-e10.png")'>
            <span class="title">Evolve进化系列<br/>E10</span>
          </p>
          <p class="menu-detail-item" @click='checkMenu("/product/t20")'>
            <img class="img" :src='require("@/assets/img/index/menu-product-t20.png")'>
            <span class="title">Touch轻触系列<br/>T20</span>
          </p>
          <p class="menu-detail-item" @click='checkMenu("/product/h30")'>
            <img class="img" :src='require("@/assets/img/index/menu-product-h30.png")'>
            <span class="title">H30 series</span>
          </p>
          <p class="menu-detail-item" @click='checkMenu("/product/luolan")'>
            <img class="img" :src='require("@/assets/img/index/menu-product-luolan.png")'>
            <span class="title">洛澜</span>
          </p>
          <p class="menu-detail-item" @click='checkMenu("/product/wrightinTwo")'>
            <img class="img" :src='require("@/assets/img/index/menu-product-wrightinTwo.png")'>
            <span class="title">T20 Max</span>
          </p>
          <p class="menu-detail-item" @click='checkMenu("/product/kegel")'>
            <img class="img" :src='require("@/assets/img/index/menu-product-kegel.png")'>
            <span class="title">凯格尔球</span>
          </p>
        </div>
      </li>
      <li>
        <div class="menu-item" @click='checkMenu("/tech")'>
          <span class="text">医研科技</span>
          <img class="arrow bottom" v-show='menu.expand=="/tech"'
               v-lazy='require("@/assets/img/index/menu-arrow-bottom.png")'>
          <img class="arrow right" v-show='menu.expand!="/tech"'
               v-lazy='require("@/assets/img/index/menu-arrow-right.png")'>
        </div>
        <div class="menu-detail-text" v-show='menu.expand=="/tech"'>
          <p class="menu-detail-item-text" @click='checkMenu("/app")'>
            澜渟 App
          </p>
          <p class="menu-detail-item-text" @click='checkMenu("/technology")'>
            科研技术
          </p>
        </div>
      </li>
      <li>
        <div class="menu-item" @click='checkMenu("/about")'>
          <span class="text">认识澜渟</span>
          <img class="arrow bottom" v-show='menu.expand=="/about"'
               v-lazy='require("@/assets/img/index/menu-arrow-bottom.png")'>
          <img class="arrow right" v-show='menu.expand!="/about"'
               v-lazy='require("@/assets/img/index/menu-arrow-right.png")'>
        </div>
        <div class="menu-detail-v2" v-show='menu.expand=="/about"'>
          <p class="menu-detail-item-v2" @click='checkMenu("/about/info")'>
            <img class="img" :src='require("@/assets/img/index/menu-about-info.png")'>
            <span class="title">公司简介</span>
          </p>
          <p class="menu-detail-item-v2" @click='checkMenu("/about/consultation")'>
            <img class="img" :src='require("@/assets/img/index/menu-about-consultation.png")'>
            <span class="title">品牌资讯</span>
          </p>
          <p class="menu-detail-item-v2" @click='checkMenu("/about/contact")'>
            <img class="img" :src='require("@/assets/img/index/menu-about-contact.png")'>
            <span class="title">联系我们</span>
          </p>
          <p class="menu-detail-item-v2" @click='checkMenu("/about/join")'>
            <img class="img" :src='require("@/assets/img/index/menu-about-join.png")'>
            <span class="title">加入我们</span>
          </p>
          <p class="menu-detail-item-v2" @click='checkMenu("/about/responsibility")'>
            <img class="img" :src='require("@/assets/img/index/menu-about-responsibility.png")'>
            <span class="title">社会责任</span>
          </p>
        </div>
      </li>
      <li>
        <div class="menu-item" @click='checkMenu("/empower")'>
          <span class="text">授权查询</span>
<!--          <img  class="arrow right" v-lazy='require("@/assets/img/index/menu-arrow-right.png")'>-->
        </div>
      </li>
    </ul>
    <div id="menuShade" v-show="menu.show" @click="hideMenu()"></div>
    <div id="content">
      <router-view />
    </div>
    <div id="bottom" :style="{'--append-height': goTopBottomAppend}">
      <p class="logo">
        <img alt v-lazy='require("@/assets/img/index/logo-white.png")' />
      </p>

      <div class="social-media">
        <p class="title">{{isMulan ? '沐澜' : ''}}社交媒体：</p>
        <div class="list">
          <template v-for="(socialMedia, index) in socialMediaConfig">
            <div @click.stop="hoverImgShow($event, socialMedia.name)"
                 class="item" :class="socialMedia.name"
                 v-if="!isMulan || (isMulan && !socialMedia.mulanHide)"></div>
          </template>
        </div>
      </div>
      <div class="app-download">
        <p class="title">应用下载：</p>
        <div class="list">
          <div class="app-item" @click.stop="hoverImgShow($event, '', 'app')">
            <img alt v-lazy="require('@/assets/img/index/app-lt.png')" />
            <p>澜渟 App</p>
          </div>
          <div class="app-item" @click.stop="hoverImgShow($event, '', 'app-doctor')">
            <img alt v-lazy="require('@/assets/img/index/app-ltd.png')" />
            <p>澜渟医生 App</p>
          </div>
        </div>
      </div>
      <p class="bottom-hotline">
        <span>服务热线：</span>
        <span @click='goPhone("400-133-5668")'>400-133-5668</span>
      </p>
      <p class="bottom-business">
        <span>经销合作：</span>
        <span @click='goPhone("18021397056")'>18021397056</span>
      </p>
      <p class="bottom-link">
        <span>友情链接：</span>
        <span class="link-span" @click='jumpUrl("https://www.medlander.com/")'>麦澜德</span>
        <span class="link-span" @click='jumpUrl("http://www.jialan365.com/")'>佳澜健康</span>
        <span class="link-span" @click='jumpUrl("http://www.reseader.com/")'>锐诗得</span>
      </p>
      <div class="bottom-copyright">
        <p class="card">互联网药品信息服务资格证书：(苏)-非经营性-2023-0070</p>
        <p class="copyright">Copyright © 2015-{{ copyRightYear }} 南京麦豆健康科技有限公司 版权所有</p>
        <p class="bei" @click='jumpUrl("https://beian.miit.gov.cn/#/Integrated/index")'>苏ICP备 17044321 号</p>
        <p class="phone">投诉举报电话: 12331</p>
      </div>

      <div class="hover-img" :class="[hoverImg.name, hoverImg.extraClass]"
           :style="{display: hoverImg.isShow ? 'block' : 'none', top: hoverImg.top, left: hoverImg.left}">
        <img :src="hoverImg.qrcodePath" alt="二维码" />
        <img :src="require('@/assets/img/index/angle.png')" alt class="angle">
      </div>
    </div>
    <div id="goTop" v-if="goTopShow" @click="goTop()" :style="{'--append-height': goTopBottomAppend}">
      <img :src='require("@/assets/img/index/to-top-white.png")' />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menu: {
        active: "/home",
        expand: "",
        show: false,
        top: -19.9,
        opacity: 0
      },
      goTopShow: false,
      windowHeight: window.innerHeight,
      copyRightYear: new Date().getFullYear(),
      isMulan: false,
      hoverImg: {
        isShow: false,
        qrcodePath: "",
        top: 0,
        left: 0,
        name: "",
        extraClass: '',
      },
      socialMediaConfig: [
        {
          name: "wechat",
          type: "qrcode",
          mulanHide: true
        },
        {
          name: "tiktok",
          type: "qrcode",
          mulanHide: false
        },
        {
          name: "xiaohongshu",
          type: "qrcode",
          mulanHide: false
        },
        {
          name: "weibo",
          type: "qrcode",
          mulanHide: true
        },
        {
          name: "zhihu",
          type: "qrcode",
          mulanHide: false
        }
      ],
      goTopBottomAppend: '0px',
    };
  },
  mounted() {
    window.addEventListener("scroll", this.bindScrollWindow, true);
    window.addEventListener("resize", this.resizeWindow, true);
  },
  methods: {
    /**
     监听页面滚动条
     @param
     @return
     */
    bindScrollWindow() {
      this.goTopShow = window.scrollY > window.screen.availHeight;
      if (this.menu.active == '/about/contact') {
        this.goTopBottomAppend = document.querySelector('.append').clientHeight + 'px';
      } else {
        this.goTopBottomAppend = 0;
      }
    },

    /**
     监听页面变化
     @param
     @return
     */
    resizeWindow() {
      this.windowHeight = window.innerHeight;
    },
    /**
     展开/收缩菜单
     @param
     @return
     */
    expandMenu() {
      if (this.menu.show) {
        this.hideMenu();
      } else {
        this.showMenu();
      }
    },
    /**
     展开菜单
     @param
     @return
     */
    showMenu() {
      this.menu.show = true;
      document.body.style.overflow = "hidden";
    },
    /**
     收缩菜单
     @param
     @return
     */
    hideMenu() {
      this.menu.show = false;
      this.menu.expand = "";
      document.body.style.overflow = "";
    },
    /**
     选中菜单
     @param {string} menu 菜单
     @return
     */
    checkMenu(menu) {
      if (menu == "/product" || menu == "/about" || menu == "/producte" || menu == "/tech") {
        if (this.menu.expand == menu) {
          this.menu.expand = "";
        } else {
          this.menu.expand = menu;
        }
        return;
      }
      this.hideMenu();
      if (this.menu.active == menu) {
        this.goTop();
        return;
      }
      this.$router.push({ path: menu });
    },
    /**
     页面跳转-澜渟旗舰店（天猫商城）
     @param
     @return
     */
    goMall() {
      window.location.href = "https://lanting.m.tmall.com";
    },
    /**
     页面跳转-工信部官网
     @param
     @return
     */
    goMiit() {
      window.location.href = "http://www.miit.gov.cn";
    },

    /**
     跳转链接
     @param {string} url 链接
     @return
     */
    jumpUrl(url) {
      window.location.href = url;
    },
    /**
     拨打电话
     @param {string} phone 电话号码
     @return
     */
    goPhone(phone) {
      window.location.href = `tel:${phone}`;
    },
    /**
     置顶
     @param
     @return
     */
    goTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    },

    hoverImgShow(event, qrcodeName, appName = "") {
      if (this.hoverImg.isShow) {
        return;
      }
      const rem = document.documentElement.style.fontSize.replace("px", "") * 1;
      this.hoverImg.isShow = true;
      if (appName === "") {
        this.hoverImg.qrcodePath = require("@/assets/img/index/social-media/qrcode/" + (this.isMulan ? "mulan_" : "") + qrcodeName + ".png");
      } else {
        this.hoverImg.qrcodePath = require("@/assets/img/index/qrcode-" + appName + ".png");
      }
      if ((qrcodeName == "wechat" && !this.isMulan) || (qrcodeName == "tiktok" && this.isMulan) || (qrcodeName === '' && appName === 'app')) {
        this.hoverImg.left = event.target.offsetLeft - (12 * rem - 6 * rem - event.target.offsetWidth) / 2 + "px";
        this.hoverImg.extraClass = 'left-no-enough';
      } else {
        this.hoverImg.left = event.target.offsetLeft - (12 * rem - event.target.offsetWidth) / 2 + "px";
      }
      this.hoverImg.top = event.target.offsetTop - ((12 + 1.2) * rem) + "px";
      this.hoverImg.name = qrcodeName;
    },

    hoverImgHide() {
      this.hoverImg.isShow = false;
      this.hoverImg.left = 0;
      this.hoverImg.top = 0;
      this.hoverImg.name = "";
      this.hoverImg.extraClass = '';
    },

    documentClick(e) {
      if (this.hoverImg.isShow) {
        this.hoverImgHide();
        e.preventDefault();
      }
    }
  },
  watch: {
    $route: {
      handler(newVal, oldVal) {
        this.menu.active = newVal.path;
        if (newVal.path == "/product/e10" || newVal.path == "/product/ekegel") {
          this.isMulan = true;
        } else {
          this.isMulan = false;
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
#main {
  position: relative;
  height: 100%;
}

#top {
  position: fixed;
  z-index: 98;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 5.6rem;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  padding: 1.6rem;

  > .top-logo {
    height: 2.4rem;
  }

  > .top-menu {
    height: 2.4rem;

    > .menu {
      height: 2.4rem;
    }

    > .menu-close {
      height: 2.4rem;
    }
  }
}

#menuDetail {
  position: fixed;
  z-index: 97;
  top: 5.6rem;
  left: 0;
  right: 0;
  background: #fff;
  height: 0;
  transition: all 0.4s;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  overflow: auto;

  > li {
    border-bottom: 0.05rem solid #eee;
    margin: 0 1.6rem;

    > .menu-item {
      position: relative;
      height: 6.5rem;
      display: flex;
      justify-content: space-between;
      align-items: center;

      > .text {
        font-weight: 500;
        font-size: 1.8rem;
        color: #333333;
        line-height: 2.5rem;
      }

      > .arrow {
        width: 2.4rem;
      }
    }

    > .menu-detail {
      display: flex;
      flex-wrap: wrap;
      gap: 1.2rem;
      padding-bottom: 1.8rem;

      > .menu-detail-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        margin-bottom: 0.2rem;

        > .img {
          width: 10.6rem;
          height: 8.8rem;
        }

        > .title {
          margin-top: 0.8rem;
          font-size: 1.2rem;
          color: #666666;
          line-height: 2rem;
          text-align: center;
        }

        > .new-icon {
          position: absolute;
          top: 0;
          left: 0;
          width: 2.9rem;
          height: 2.1rem;
        }
      }
    }

    > .menu-detail-text {
      padding-left: 2rem;

      > .menu-detail-item-text {
        font-size: 1.4rem;
        color: #666666;
        line-height: 2rem;
        margin-bottom: 2rem;
      }
    }

    > .menu-detail-v2 {
      display: flex;
      flex-wrap: wrap;
      gap: 1.2rem;
      padding-bottom: 0.8rem;

      > .menu-detail-item-v2 {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;

        > .img {
          width: 16.5rem;
          height: 12.2rem
        }

        > .title {
          margin-top: 0.8rem;
          font-size: 1.4rem;
          color: #666666;
          line-height: 2rem;
        }
      }
    }
  }
}

#menuShade {
  position: fixed;
  z-index: 96;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #000;
  opacity: 0.65;
}

#content {
  clear: both;
  position: relative;
  padding-top: 5.6rem;
  min-height: 100%;
}

#bottom {
  position: relative;
  background-color: #000000;

  > .hover-img {
    position: absolute;
    background: #fff;
    width: 12rem;
    height: 12rem;
    padding: 0.6rem;
    border-radius: 1.2rem;

    &.left-no-enough {
      > .angle {
        left: 2.3rem;
      }
    }

    > .angle {
      position: absolute;
      top: 100%;
      left: 5.3rem;
      width: 1.4rem;
      height: 0.8rem;
    }

    > img {
      width: 100%;
    }
  }

  > .logo {
    width: 100%;
    text-align: center;
    padding-top: 3.2rem;

    > img {
      width: 16.6rem;
      height: 3rem;
    }
  }

  > .social-media {
    margin-top: 3.2rem;
    padding: 0 1.6rem;

    > .title {
      font-weight: 500;
      font-size: 1.4rem;
      color: #FFFFFF;
      line-height: 2rem;
      letter-spacing: 1px;
    }

    > .list {
      margin-top: 1.2rem;
      display: flex;

      > .item {
        width: 4rem;
        height: 4rem;
        margin-left: 2rem;
        cursor: pointer;
        background-size: 100% !important;

        &.tiktok {
          background: url(./assets/img/index/social-media/tiktok.png) no-repeat center;
        }

        &.wechat {
          background: url(./assets/img/index/social-media/wechat.png) no-repeat center;
        }

        &.xiaohongshu {
          background: url(./assets/img/index/social-media/xiaohongshu.png) no-repeat center;
        }

        &.weibo {
          background: url(./assets/img/index/social-media/weibo.png) no-repeat center;
        }

        &.zhihu {
          background: url(./assets/img/index/social-media/zhihu.png) no-repeat center;
        }

        &:first-child {
          margin-left: 0;
        }
      }
    }
  }

  > .app-download {
    margin-top: 4.9rem;
    padding: 0 1.6rem;

    > .title {
      font-weight: 500;
      font-size: 1.4rem;
      color: #FFFFFF;
      line-height: 2rem;
      letter-spacing: 1px;
    }

    > .list {
      margin-top: 1.2rem;
      display: flex;

      > .app-item {
        height: 8.4rem;
        margin-right: 4rem;
        display: flex;
        flex-direction: column;
        align-items: center;

        > img {
          width: 6rem;
        }

        > p {
          margin-top: 0.6rem;
          text-align: center;
          font-size: 1.3rem;
          color: #FFFFFF;
          line-height: 1.8rem;
        }
      }
    }
  }

  > .bottom-hotline {
    margin-top: 4.9rem;
  }

  > .bottom-business, > .bottom-link {
    margin-top: 1.2rem;
  }

  > .bottom-hotline, > .bottom-business, > .bottom-link {
    padding: 0 1.6rem;

    > span {
      font-size: 1.4rem;
      color: #999999;
      line-height: 2rem;
      letter-spacing: 1px;

      &:active {
        color: #7F4DC9;
      }

      &.link-span {
        margin-right: 2.4rem;
      }

      &:nth-child(1) {
        font-weight: 500;
        color: #FFFFFF;
      }
    }
  }

  > .bottom-copyright {
    margin-top: 1.8rem;
    border-top: 0.05rem solid rgba(255, 255, 255, 0.2);
    padding: 2rem 4.8rem;
    padding-bottom: calc(2rem + var(--append-height));
    padding-bottom: calc(2rem + var(--append-height) + constant(safe-area-inset-bottom));
    padding-bottom: calc(2rem + var(--append-height) + env(safe-area-inset-bottom));

    > p {
      text-align: center;
      font-size: 1rem;
      color: #666666;
      line-height: 1.4rem;
      white-space: nowrap;

      &.card {
        margin-bottom: 0.8rem;
      }

      &.phone {
        margin-top: 0.8rem;
      }
    }
  }
}

#goTop {
  position: fixed;
  z-index: 97;
  bottom: calc(1.6rem + var(--append-height));
  bottom: calc(1.6rem + var(--append-height) + constant(safe-area-inset-bottom));
  bottom: calc(1.6rem + var(--append-height) + env(safe-area-inset-bottom));
  right: 1.6rem;
  width: 3.8rem;
  height: 3.8rem;
  background: rgba(102, 102, 102, 0.3);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  >img {
    width: 2rem;
  }
}
</style>

<style lang="scss">
@import './assets/css/common.scss';
</style>
